/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Platforms_Linux_DescInputs */

const en_fc_home_platforms_linux_desc = /** @type {(inputs: Fc_Home_Platforms_Linux_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AppImage, Flatpak, .deb, .rpm and Arch packages for x86_64 and ARM64, plus RISC-V builds. FreeBSD gets a tarball too.`)
};

/**
* | output |
* | --- |
* | "AppImage, Flatpak, .deb, .rpm and Arch packages for x86_64 and ARM64, plus RISC-V builds. FreeBSD gets a tarball too." |
*
* @param {Fc_Home_Platforms_Linux_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_platforms_linux_desc = /** @type {((inputs?: Fc_Home_Platforms_Linux_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Platforms_Linux_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_platforms_linux_desc(inputs)
});
export { fc_home_platforms_linux_desc as "fc.home.platforms.linux.desc" }